import { render, staticRenderFns } from "./VoucherAndRoomInformationRoomType.vue?vue&type=template&id=60218a37&scoped=true"
import script from "./VoucherAndRoomInformationRoomType.vue?vue&type=script&lang=js"
export * from "./VoucherAndRoomInformationRoomType.vue?vue&type=script&lang=js"
import style0 from "./VoucherAndRoomInformationRoomType.vue?vue&type=style&index=0&id=60218a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60218a37",
  null
  
)

export default component.exports